// extracted by mini-css-extract-plugin
export default {"SiteOrange":"#EF7C00","SiteLightGrey":"#B1B1B1","Main":"Spinner_Main__5GxSw","MainPadding":"Spinner_MainPadding__UPayE","Orange":"Spinner_Orange__jX066","Gray":"Spinner_Gray__o-Rc+"};